import { string } from 'prop-types';

export default function LogoIcon({ width, height }) {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	    viewBox="239.7955780029297 239.8956756591797 600.2089233398438 600.2089233398438" xmlSpace="preserve"
      width={width}
      height={height}
      fill="#005042"
      style={{enableBackground: 'new 0 0 1080 1080'}}
      >
      <g>
        <g>
          <path d="M499.6,658.4c-0.4,0.3-0.8,0.6-1.3,0.9c-11.4,7.8-22.9,15.6-34.4,23.4l-13.7,9.4c-1.4-1-2.8-2-4.3-3
            c-5.1-3.6-10.4-7.4-15.7-11c-4.9-3.3-9.9-6.7-14.8-10c-24.2-16.3-49.2-33.1-71.8-52.4c-28.4-24.3-46.7-45.7-59.4-69.6
            c-14.6-27.4-20.1-54.2-17.1-81.9c4.9-43.7,41.6-79,85.5-82c2.7-0.2,5.3-0.3,8-0.3c22.1,0,41.5,6.7,58,20
            c4.6-7.5,9.9-14.6,15.7-21.1c-27.9-22-60.5-29.8-97.3-23.2c-55.9,10-97.7,61.1-97.2,118.8c0.3,35.8,11.2,69.7,32.3,100.7
            c18.4,27,42.3,51.1,73.1,73.6c23.6,17.3,48,34.3,71.5,50.7c10.3,7.2,20.6,14.4,30.8,21.6l2.4,1.7l2.4-1.7
            c5.9-4.1,11.9-8.2,17.8-12.4c13-9,26.4-18.4,39.7-27.4c4-2.7,7.9-5.4,11.9-8.2c-3.3-2.4-6.7-4.8-10-7.2
            C507.8,664.7,503.7,661.6,499.6,658.4z"/>
          <path d="M812.8,569.1c0.1-0.2,0.3-0.4,0.4-0.6c1-1.6,2-3.2,2.9-4.9c0.1-0.1,0.2-0.3,0.2-0.4h0
            c15.4-27.2,23.4-56.3,23.7-86.8c0.5-57.7-41.3-108.8-97.2-118.8c-36.8-6.6-69.4,1.2-97.3,23.2c5.9,6.5,11.1,13.6,15.7,21.1
            c16.5-13.3,35.9-20,58-20c2.6,0,5.3,0.1,8,0.3c43.9,3.1,80.7,38.3,85.5,82c3.1,27.6-2.5,54.4-17.1,81.9
            c-3.1,5.8-6.5,11.5-10.4,17.1h-0.1c-5.6,8.2-12.1,16.2-19.4,24.2c-6.5,7.1-13.3,13.8-20.4,20.1c-0.6,0.6-1.3,1.2-2,1.8
            c-2.8,2.5-5.7,5-8.6,7.4c-1.2,1-2.4,2-3.6,3c-2.4,2-4.9,4-7.3,5.9c-1,0.8-2.1,1.6-3.1,2.4c-2.6,2-5.2,4-7.8,5.9
            c-1,0.7-2,1.5-2.9,2.2c-3,2.2-6,4.4-9,6.5c-3,2.2-6,4.3-9.1,6.4c-0.1,0.1-0.2,0.2-0.3,0.2c-9.1,6.3-18.3,12.5-27.3,18.6
            c-4.9,3.3-9.9,6.6-14.8,10c-4.2,2.9-8.4,5.8-12.4,8.7l-7.7,5.3l-7.9-5.4c-4-2.9-8.1-5.7-12.2-8.6c-4.9-3.3-9.9-6.7-14.8-10
            c-24.2-16.2-49.1-33-71.6-52.2c0,0,0,0,0,0c-10.3-8.8-20.4-18.2-29.7-28.3c-6.4-6.9-12.1-13.9-17.1-21c0,0,0,0,0-0.1
            c-15.2-21.2-24.6-43-28.5-66.1c-3.6-21.3-2.8-38.3,2.7-53.6c13.2-36.8,39.1-58.3,76.9-63.9c7-1,14-1.2,21-0.5
            c1.5,0.2,3,0.3,4.5,0.5c3,0.4,5.9,1,8.7,1.6c16.9,4.1,32.8,12.8,46,25.2c9.4,9.8,16.9,22.2,22.2,37.1c5.5,15.3,6.4,32.3,2.7,53.6
            c-5.3,30.9-20.2,59.4-45.7,87.2c-9.3,10.2-19.4,19.6-29.7,28.3c7.2,5.4,14.6,10.7,22,15.9c8.6-7.6,17-15.5,25-24.1
            c33.6-36,52-73.6,56.1-115c2-20.2,0.3-37.8-5-53.6c-11.6-34.1-35.2-59.7-65.7-73.1c-0.3-0.1-0.6-0.3-0.9-0.4
            c-0.8-0.3-1.6-0.7-2.5-1c-13.5-5.7-27.9-8.7-43-8.9c-0.6,0-1.1-0.1-1.7-0.1c-0.4,0-0.9,0-1.3,0c-0.4,0-0.9,0-1.3,0
            c-0.6,0-1.1,0-1.7,0.1c-15.1,0.2-29.4,3.2-43,8.9c-0.8,0.3-1.6,0.7-2.5,1c-0.3,0.1-0.6,0.3-0.9,0.4c-30.5,13.4-54.1,39-65.7,73.1
            c-5.4,15.8-7,33.4-5,53.6c2.7,27.1,11.5,52.6,26.6,77c0.3,0.4,0.5,0.9,0.8,1.3c1.1,1.7,2.1,3.3,3.3,5c0.3,0.4,0.5,0.9,0.8,1.3
            c0.2,0.3,0.4,0.6,0.6,0.9c1.7,2.5,3.5,5,5.3,7.4c17.5,23.6,39.5,45.1,67.2,65.3c11.1,8.1,22.3,16.2,33.6,24.1
            c-0.1,0.1-0.2,0.1-0.3,0.2c3.9,2.7,7.9,5.4,11.9,8.2c3.6,2.5,7.2,5,10.9,7.5c5.2,3.6,10.3,7.2,15.4,10.8
            c10.3,7.2,20.6,14.4,30.8,21.6l2.4,1.7l0.3-0.2l0.2,0.2l2.4-1.7c10.2-7.2,20.5-14.4,30.8-21.6c5.6-3.9,11.2-7.8,16.9-11.8
            c3.1-2.2,6.3-4.3,9.4-6.4c18-12.2,35.6-24.6,52.4-37.9c21.9-16.8,40.2-34.6,55.3-53.7c0.3-0.3,0.5-0.7,0.8-1
            c1.2-1.6,2.5-3.1,3.7-4.7c1.8-2.4,3.6-4.9,5.2-7.3c0.3-0.5,0.7-0.9,1-1.4c0.5-0.7,1-1.5,1.4-2.2c0.2-0.3,0.4-0.6,0.6-0.9
            C810.8,572.3,811.8,570.7,812.8,569.1z"/>
        </g>
      </g>
      </svg>
  );
}

LogoIcon.propTypes = {
  width: string,
  height: string,
};

LogoIcon.defaultProps = {
  width: '44px',
  height: '44px',
};
